import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  const newsEventsCarousels = document.querySelectorAll(
    '.carrousel-news .carrousel-news__carousel'
  );

  if (0 < newsEventsCarousels.length) {
    newsEventsCarousels.forEach((newsEventsCarousel) => {
      new Swiper(newsEventsCarousel, {
        slidesPerView: 1.2,
        spaceBetween: 24,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
        },
        breakpoints: {
          600: {
            slidesPerView: 2.2,
          },
          900: {
            slidesPerView: 3.2,
          },
        },
      });
    });
  }
});
